// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"p6TZNVGfbypQP5vuXosVy","listWrapper":"_1udp2Gxjswe21PPS7ItemY"};